import { useEffect, useEffectEvent, useRef } from 'react';
/**
 * Replaces a query's `onCompleted`, which Apollo Client 4 removes. Runs once per result object, so
 * a cached first delivery and any cache write that changes the result also run it.
 */
export function useOnQueryResult(data, onResult) {
    const lastHandled = useRef(undefined);
    const onNewResult = useEffectEvent(onResult);
    useEffect(() => {
        // A skipped query hands back `undefined` and then the same cached object again.
        if (data === undefined || data === lastHandled.current) {
            return;
        }
        lastHandled.current = data;
        onNewResult(data);
    }, [data]);
}
